export function Footer() {
  return (
    <footer class="site-footer">
      <p>
        <a href="https://github.com/fiddur/aurboda">Aurboda</a> ©Fredrik Liljegren {new Date().getFullYear()}{' '}
        <a href="http://www.gnu.org/licenses/agpl-3.0.html">GNU AGPL-3.0</a> · <a href="/privacy">Privacy</a>{' '}
        · <a href="/terms">Terms</a>
      </p>
    </footer>
  )
}
